module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": 4
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n       " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "noPaddingBottom"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "ethnicityTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "ethnicity",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "ethnicity",
      "errorText": _vm.errors.first('ethnicity'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.accountPreferencesEthnicity'),
      "label": _vm.$t('message.accountPreferencesEthnicity')
    },
    model: {
      value: (_vm.model.ethnicity_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "ethnicity_id", $$v)
      },
      expression: "model.ethnicity_id"
    }
  }, _vm._l((_vm.lists.ethnicities), function(item, index) {
    return _c('mu-menu-item', {
      key: 'ethnicity-' + index,
      attrs: {
        "title": _vm.$t(_vm.localizeEthnicity(item.ethnicity_id)),
        "value": item.ethnicity_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "languageTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "language",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "language",
      "errorText": _vm.errors.first('language'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesLanguage')
    },
    model: {
      value: (_vm.model.language_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "language_id", $$v)
      },
      expression: "model.language_id"
    }
  }, _vm._l((_vm.lists.languages), function(item, index) {
    return _c('mu-menu-item', {
      key: 'language-' + index,
      attrs: {
        "value": item.id,
        "title": _vm.getNativeName(item.iso)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "occupationTxt",
      "autoWidth": "",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "occupation",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesOccupation'),
      "errorText": _vm.errors.first('occupation'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": "Select",
      "label": _vm.$t('message.accountPreferencesOccupation')
    },
    model: {
      value: (_vm.model.occupation_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "occupation_id", $$v)
      },
      expression: "model.occupation_id"
    }
  }, _vm._l((_vm.lists.occupations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'occupatation-' + index,
      attrs: {
        "value": item.occupation_id,
        "title": _vm.localizeOccupation(item.occupation_name)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeFoodsTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeFoodsSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "favouriteSearch"
    }
  }, [_c('mu-auto-complete', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "id": "searchFoodTxt",
      "scroller": _vm.scroller,
      "fullWidth": _vm.fullWidth,
      "filter": "noFilter",
      "hintText": _vm.$t('message.labelStartTyping'),
      "maxHeight": 250,
      "openOnFocus": true,
      "dataSource": _vm.favouriteDataSource,
      "dataSourceConfig": _vm.foodDataSourceConfig,
      "icon": "search"
    },
    on: {
      "change": _vm.handleFavouriteSelected
    },
    model: {
      value: (_vm.favouriteSearch),
      callback: function($$v) {
        _vm.favouriteSearch = $$v
      },
      expression: "favouriteSearch"
    }
  }), _vm._v(" "), (_vm.foodSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.favouriteModel), function(item, index) {
    return _c('mu-chip', {
      key: 'favorite-' + index
    }, [_c('mu-icon', {
      attrs: {
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.favouriteModel.splice(index, 1)
        }
      }
    }), _vm._v("\n                " + _vm._s(item.food_name) + "\n              ")], 1)
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeDietaryPreferencesTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeDietaryPreferencesSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "noPaddingBottom"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "100"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "dietaryPreferenceTxt",
      "scroller": _vm.scroller,
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "dietry_preference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDietaryPreference'),
      "errorText": _vm.errors.first('dietry_preference'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDietaryPreference')
    },
    model: {
      value: (_vm.model.dietry_preference_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "dietry_preference_id", $$v)
      },
      expression: "model.dietry_preference_id"
    }
  }, _vm._l((_vm.lists.dietry_preferences), function(item, index) {
    return _c('mu-menu-item', {
      key: 'dietary-preference-' + index,
      attrs: {
        "value": item.dietry_preference_id,
        "title": _vm.localizeDietPreference(item.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "id": "allergiesTxt",
      "scroller": _vm.scroller,
      "multiple": "",
      "separator": ", ",
      "autoWidth": "",
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesAllergies')
    },
    model: {
      value: (_vm.model.allergies),
      callback: function($$v) {
        _vm.$set(_vm.model, "allergies", $$v)
      },
      expression: "model.allergies"
    }
  }, _vm._l((_vm.lists.allergies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'allergy-' + index,
      attrs: {
        "value": item.allergy_id,
        "title": _vm.localizeAllergy(item.name)
      }
    })
  }), 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.currency.currency) ? _c('currency-input', {
    attrs: {
      "label": _vm.$t('message.accountPreferencesShopCost'),
      "currency": _vm.currency.currency
    },
    model: {
      value: (_vm.model.weekly_shop_cost),
      callback: function($$v) {
        _vm.$set(_vm.model, "weekly_shop_cost", _vm._n($$v))
      },
      expression: "model.weekly_shop_cost"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-row'), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1), _vm._v(" "), _c('mu-card-header', {
    staticClass: "noPaddingTop",
    attrs: {
      "title": _vm.$t('message.gettingStartedPersonalizeHealthTitle'),
      "subTitle": _vm.$t('message.gettingStartedPersonalizeHealthSubTitle')
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }, [(_vm.settings.hba1c && _vm.isDiabetic) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.activeHba1cType.measure === 'percentage'),
      expression: "activeHba1cType.measure === 'percentage'"
    }],
    attrs: {
      "id": "hba1cPercentTxt",
      "data-vv-name": "hba1c_percent",
      "data-vv-rules": 'min_value:3|max_value:25',
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c_percent'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "label": "HbA1c"
    },
    model: {
      value: (_vm.hba1cModel.percent),
      callback: function($$v) {
        _vm.$set(_vm.hba1cModel, "percent", _vm._n($$v))
      },
      expression: "hba1cModel.percent"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.activeHba1cType.measure === 'mmol-mol'),
      expression: "activeHba1cType.measure === 'mmol-mol'"
    }],
    attrs: {
      "id": "hba1cMmolmolTxt",
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-rules": 'min_value:8|max_value:300',
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c_mmol_mol'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "label": "HbA1c"
    },
    model: {
      value: (_vm.hba1cModel.mmol_mol),
      callback: function($$v) {
        _vm.$set(_vm.hba1cModel, "mmol_mol", _vm._n($$v))
      },
      expression: "hba1cModel.mmol_mol"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "hba1cSettingTxt",
      "autoWidth": "",
      "data-vv-name": "hba1c",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c",
      "errorText": _vm.errors.first('hba1c'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "hintText": "Select",
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.hba1c),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "hba1c", $$v)
      },
      expression: "settingsModel.hba1c"
    }
  }, _vm._l((_vm.settings.hba1c.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isDiabetic) ? _c('mu-row', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "hba1cEvaluationTxt",
      "autoWidth": "",
      "data-vv-name": "hba1c_month_id",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "HbA1c evaluation",
      "autoWidth": "",
      "errorText": _vm.errors.first('hba1c_month_id'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "label": _vm.$t('message.labelLastHbA1c'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.hba1c_month_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "hba1c_month_id", $$v)
      },
      expression: "model.hba1c_month_id"
    }
  }, _vm._l((_vm.lists.hba1c_months), function(item, index) {
    return _c('mu-menu-item', {
      key: 'hba1c-month-' + index,
      attrs: {
        "value": item.id,
        "title": item.name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settings.height) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsModel.height === 1),
      expression: "settingsModel.height === 1"
    }]
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.settingsModel.height === 1) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:8'),
      expression: "'required|min_value:0|max_value:8'"
    }],
    attrs: {
      "id": "heightFtTxt",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_ft",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "min": 0,
      "max": 8,
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "FT",
      "label": _vm.$t('message.labelHeight'),
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.heightModel.ft),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "ft", _vm._n($$v))
      },
      expression: "heightModel.ft"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [(_vm.settingsModel.height === 1) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:11'),
      expression: "'required|min_value:0|max_value:11'"
    }],
    attrs: {
      "id": "heightInTxt",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_in",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "min": 0,
      "max": 11,
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "IN",
      "label": " ",
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.heightModel.in),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "in", _vm._n($$v))
      },
      expression: "heightModel.in"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('mu-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsModel.height === 2),
      expression: "settingsModel.height === 2"
    }]
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [(_vm.settingsModel.height === 2) ? _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:50|max_value:251'),
      expression: "'required|min_value:50|max_value:251'"
    }],
    attrs: {
      "id": "heightCmTxt",
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "errorText": _vm.errors.first('height_cm'),
      "label": "Height",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth,
      "type": "number"
    },
    model: {
      value: (_vm.heightModel.cm),
      callback: function($$v) {
        _vm.$set(_vm.heightModel, "cm", _vm._n($$v))
      },
      expression: "heightModel.cm"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "heightSettingsTxt",
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "height",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "height",
      "errorText": _vm.errors.first('height'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": "Select",
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.height),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "height", $$v)
      },
      expression: "settingsModel.height"
    }
  }, _vm._l((_vm.settings.height.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'height-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.settings.weight) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "70",
      "desktop": "70",
      "tablet": "70"
    }
  }, [(_vm.settingsModel.weight === 1) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightKgTxt",
      "min": 20,
      "max": 750,
      "data-vv-rules": 'required|min_value:20|max_value:635',
      "data-vv-name": "weight_kg",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "kg",
      "errorText": _vm.errors.first('weight_kg'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number"
    },
    model: {
      value: (_vm.weightModel.kg),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "kg", _vm._n($$v))
      },
      expression: "weightModel.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingsModel.weight === 2) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightLbsTxt",
      "min": 0,
      "max": 1102,
      "data-vv-rules": 'required|min_value:20|max_value:1400',
      "data-vv-name": "weight_lbs",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "lbs",
      "errorText": _vm.errors.first('weight_lbs'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.lbs),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "lbs", _vm._n($$v))
      },
      expression: "weightModel.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.settingsModel.weight === 3) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightStonesTxt",
      "min": 0,
      "max": 92,
      "data-vv-rules": 'required|min_value:0|max_value:92',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "stones",
      "errorText": _vm.errors.first('stones'),
      "label": _vm.$t('message.cardWeight'),
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "helpText": "ST",
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.stones),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "stones", _vm._n($$v))
      },
      expression: "weightModel.stones"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightPoundsTxt",
      "min": 0,
      "max": 13,
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "pounds",
      "errorText": _vm.errors.first('pounds'),
      "label": " ",
      "helpText": "LBS",
      "type": "number",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": _vm.fullWidth
    },
    model: {
      value: (_vm.weightModel.pounds),
      callback: function($$v) {
        _vm.$set(_vm.weightModel, "pounds", _vm._n($$v))
      },
      expression: "weightModel.pounds"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "weightSettingsTxt",
      "autoWidth": "",
      "data-vv-rules": 'required',
      "data-vv-name": "weight",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "weight",
      "errorText": _vm.errors.first('weight'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 370,
      "hintText": _vm.$t('message.selectText'),
      "label": ' '
    },
    model: {
      value: (_vm.settingsModel.weight),
      callback: function($$v) {
        _vm.$set(_vm.settingsModel, "weight", $$v)
      },
      expression: "settingsModel.weight"
    }
  }, _vm._l((_vm.settings.weight.dropdown), function(item, index) {
    return _c('mu-menu-item', {
      key: 'weight-dropdown-' + index,
      attrs: {
        "value": item.preference_id,
        "title": item.unit
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "width": "100",
      "tablet": "100"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "fullWidth": true,
      "secondary": "",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a9e9bde","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GettingStarted/Personalise.vue
// module id = 3812
// module chunks = 1